'use client';

import { useEffect, useState } from 'react';
import { useBannerState } from '../contexts/BannerContext';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useMediaQuery from '../useMediaQuery';
import { SM_BREAKPOINT } from '../constants';

export function useAnimatedNavbarHeight() {
  const [navPlusBannerHeight, setNavPlusBannerHeight] = useState(82);

  const { isBannerOpen } = useBannerState();

  const isMobile = useMediaQuery(`(max-width: ${SM_BREAKPOINT}px)`);

  useEffect(() => {
    // get values from CSS variable
    const rootStyles = getComputedStyle(document.documentElement);
    const navbarHeight = rootStyles.getPropertyValue('--navbarHeight');
    const navbarBannerHeight = rootStyles.getPropertyValue('--navbarBannerHeight');

    // get navbarbanner height if on mobile
    const navBannerMobileHeight = rootStyles.getPropertyValue('--navbarBannerMobileHeight');

    // if on mobile, use the mobile banner height
    const navbarBannerHeightToUse = isMobile ? navBannerMobileHeight : navbarBannerHeight;

    // convert to number and remove 'px'
    const navHeight = parseFloat(navbarHeight);
    const navBannerHeight = parseFloat(navbarBannerHeightToUse);

    // Update state based on if Banner is open or not
    setNavPlusBannerHeight(navHeight + (isBannerOpen ? navBannerHeight : 0));
    const timeoutId = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isBannerOpen, isMobile]);

  return [navPlusBannerHeight];
}
